module.exports = __webpack_public_path__ + "media/media/tak-background-video-98a859d3695ad35fae97fba6aed372ac.mp4";